import {State} from './usePlayersReducer';

const localStorageKey = (gameId: number | string) => `fantasy/${gameId}`;

type LineupState = Pick<State, 'formation' | 'numberOfPlayers' | 'players' | 'substitutes' | 'overallCost'>;

function setLineup(gameId: string | number, state: LineupState) {
  localStorage.setItem(localStorageKey(gameId), JSON.stringify(state));
}

function getLineup(gameId: string | number) {
  const state = localStorage.getItem(localStorageKey(gameId));
  if (state === null) return null;
  return JSON.parse(state) as LineupState;
}

function removeLineup(gameId: string | number) {
  localStorage.removeItem(localStorageKey(gameId));
}

export const lineupCache = {getLineup, setLineup, removeLineup};
